<template>
  <div>
    <card>
      <Form inline :model="searchForm">
        <FormItem label="校区名" :label-width="60">
          <Input type="text" v-model="searchForm.name"/>
        </FormItem>
        <FormItem>
          <Button type="primary" size="small" @click="getZoneList" :loading="loading">
            <span v-if="!loading">查询</span>
            <span v-else>查询中</span>
          </Button>
          <Button type="primary" size="small" style="margin-left: 5px;" @click="add">新增</Button>
        </FormItem>
      </Form>

      <Table :columns="zoneTable.columns" :data="zoneTable.data">
          <template slot-scope="{ row, index }" slot="name">
              <div style="text-align: left;padding:5px;">
                  <span style="font-size:18px;font-weight:bold">{{row.name}}</span><br>
                  <span style="font-size:12px;color:#666">{{row.address}}</span>
              </div>

          </template>
          <template slot-scope="{ row, index }" slot="contact">
              {{row.contact}}<br>
              {{row.phone}}
          </template>
          <template slot-scope="{ row, index }" slot="other">
              一对一请假时间限制：{{row.cancellimitone}}小时<br>
              班课请假时间限制：{{row.cancellimitclass}}小时<br>
              <div v-if="row.cancelby == 1">
                  校区管理员审核请假
              </div>
              <div v-if="row.cancelby == 2">
                  教师审核请假
              </div>
          </template>
      </Table>
      <Pagination :pageTotalNum="pageTotalNum"
                  :pageCurrent="pageCurrent"
                  :pageSize="pageSize"
                  @changePage="changePage"
                  @pageSizeChange="pageSizeChange"/>
    </card>
    <zone-form ref="zoneForm" @refresh="getZoneList"></zone-form>
  </div>
</template>
<script>
  import zoneForm from './zone_form'
  import Pagination from '../../utils/pagination'
  export default {
    name: 'zone_index',
    components: {
      zoneForm,
      Pagination
    },
    data() {
      return {
        loading:false,
        pageCurrent: 1,
        pageSize: 10,
        pageTotalNum: 0,
        searchForm: {
          name: ''
        },
        zoneTable: {
          columns: [
            {
              title: '名称',
              slot: 'name',
              align: 'center'
            },
            {
              title: '联系方式',
              slot: 'contact',
              align: 'center'
            },
            {
              title: '设置',
              slot: 'other',
              align: 'center'
            },
            {
              title:'备注',
              key:'remark',
              align:'center'
            },
            {
              title: '操作',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.zoneForm.id=params.row.id;
                      this.$refs.zoneForm.init()
                      this.$refs.zoneForm.getZoneDetail();
                      this.$refs.zoneForm.showModal=true;
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let self=this;
                      this.$Modal.confirm({
                        title:'确认删除?',
                        content:'删除校区将同时删除校区所有排课、预约、财务等所有信息，请谨慎操作，删除后不可恢复！！！',
                        onOk(){
                          self.$api.zone.delZone({id:params.row.id}).then(res=>{
                            if(res.state=="ok"){
                              self.$Message.info("删除成功");
                              self.getZoneList()
                            }else{
                              this.$Message.error(res.msg)
                            }
                          })
                        },
                        onClose(){

                        }
                      })


                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }
          ],
          data: []
        }
      }
    },
    methods: {
      getZoneList() {
        this.loading=true
        this.zoneTable.data=[]
        this.pageTotalNum=0;
        let param = {
          name: this.searchForm.name,
          page:this.pageCurrent,
          size:this.pageSize
        }
        this.$api.zone.getZoneList(param).then(res => {
          if(res.state=="ok"){
            this.pageTotalNum=(Number)(res.totalRow);
            this.zoneTable.data=res.zoneList.list;
          }else{
            this.$Message.error(res.msg);
          }
          this.loading=false
        })
      },
      add(){
        this.$refs.zoneForm.id=null
        this.$refs.zoneForm.init()
        this.$refs.zoneForm.showModal=true;
      },
      //触发每页显示条数
      pageSizeChange(pageSize) {
        this.pageSize = pageSize
        this.getZoneList()
      },
      changePage(page) {
        this.pageCurrent = page
        this.getZoneList()
      },
    },
    mounted(){
      this.getZoneList()
    }
  }
</script>
